import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from "prop-types"

import ProfileAboutItemPerso from '../userPaygoInfoProfile/profile-user-info.jsx';
import ProfileAboutItemPersoD from '../userPaygoInfoProfileDynamic/profile-user-info.jsx';
import ProfileUserFamilyInfo from'../userPaygoInfoProfileDynamic/profile-user-family-info.jsx';
import ProfileUserProspectInfo from '../userPaygoInfoProfileDynamic/profile-user-prospect-info.jsx';
import ProfileUserOtherInfo from '../userPaygoInfoProfileDynamic/profile-user-other-info.jsx';
import ProfileUserQuoteInfo from '../userPaygoInfoProfileDynamic/profile-user-quote-info.jsx';
import ProfilUserComplementInfo from '../userPaygoInfoProfileDynamic/profile-user-complementaryInfo.jsx';
import { Grid } from '@material-ui/core';

class ClientInfo extends Component {
    static propTypes = {
        profile_list: PropTypes.array.isRequired, // USER, FAMILY, PROSPECT, OTHER
        userID: PropTypes.string,
        // boxAssoId: PropTypes.string.isRequired
    };
    state = {

    }
    componentWillMount= async() => {
        this.getUserInfo()    
    }
    getUserInfo = async () => {
        const { userInfo, boxAssoId } = this.props;
        // console.log('===============getUserInfo=====================');
        // console.log({userInfo});
        // console.log('====================================');
        let methodName = 'Get user Info : '+ boxAssoId;
        var url = "/user/info/paygo?boxAssoId=" + boxAssoId;
        try{
            const res = await fetch(url, {
                method:'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',
            })
            const data = await res.json()
            //CHECK ERR
            this.setState({
                name: data.info.Nom || "",
                phone: data.info["Téléphone 1"] || "",
                email: data.info.Email || "",
                address: data.info.Adresse || "",
                city: data.info.city || "",
                country: data.info.country || "",
                gender: data.info.Type || "",
                phone2: data.info.phone2 || "",
                carteId: data.info["Numéro de carte Identité"] || ""
            });

        } catch (e) {
            // les instructions utilisées pour gérer les
            // exceptions
            console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
            console.log(e); // on transfère l'objet de l'exception à une méthode
            return;
        }
    }
    
    render (){
        const { profile_list, userInfo, boxAssoId } = this.props
        return (
            <Grid container spacing={2} >
                 {(profile_list.includes("USER") && !boxAssoId )&&
                    
                    <Grid item xs={12} >
                        <ProfileAboutItemPerso 
                            boxId={userInfo.idBox} 
                            name={this.state.name}
                            phone={this.state.phone}
                            email={this.state.email}
                            adress={this.state.address}
                            city={this.state.city}
                            country={this.state.country}
                            gender={this.state.gender}
                            phone2={this.state.phone2}
                            carteId={this.state.carteId}
                        />
                    </Grid>
                    
                }
                {(profile_list.includes("USER") && boxAssoId ) &&
                    <Grid item xs={12} >
                        <ProfileAboutItemPersoD boxAssoId={boxAssoId} />
                    </Grid>
                }
                {profile_list.includes("FAMILY") && 
                    <Grid item xs={12} >
                        <ProfileUserFamilyInfo boxAssoId={ boxAssoId }/>
                    </Grid>
                }
                {profile_list.includes("PROSPECT") && 
                    <Grid item xs={12} >
                        <ProfileUserProspectInfo boxAssoId={ boxAssoId }/>
                    </Grid>
                }
                {profile_list.includes("OTHER") && 
                    <Grid item xs={12} >
                        <ProfileUserOtherInfo boxAssoId={ boxAssoId }/>
                    </Grid>
                }
                {profile_list.includes("QUOTE") && 
                    <Grid item xs={12} >
                        <ProfileUserQuoteInfo boxAssoId={ boxAssoId }/>
                    </Grid>
                }
                {/* {profile_list.includes("COMPLEMENT_INFO") && // NOT USED
                    <ProfilUserComplementInfo userId={userID}  boxId={ boxAssoId }/>
                } */} 
            </Grid>
        )
    }
}

export default ClientInfo;